import React, { useState, useEffect } from "react";
import { useParams, NavLink, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import { Variables } from "../../Variations/Variations";
import { toast } from "react-toastify";
import {
  MdOutlineDelete,
  MdOutlineAssignmentReturned,
  MdManageSearch,
  MdOutlineManageSearch,
} from "react-icons/md";
import { AiOutlineRight } from "react-icons/ai";
import DataTable from "react-data-table-component";
import { Button, Modal } from "react-bootstrap";

const ManageGroup = () => {
  const [name, setName] = useState("");
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const { GroupID } = useParams();
  const navigate = useNavigate();

  const [unassignedAttributeValues, setUnassignedAttributeValues] = useState(
    []
  );
  const [
    filteredUnassignedAttributeValues,
    setFilteredUnassignedAttributeValues,
  ] = useState([]);
  const [assignedAttributeValues, setAssignedAttributeValues] = useState([]);
  const [filteredAssignedAttributeValues, setFilteredAssignedAttributeValues] =
    useState([]);
  const [isOpenUnAssignedAttributeValues, setIsOpenUnAssignedAttributeValues] =
    useState(false);

  const [unassignedAttributes, setUnassignedAttributes] = useState([]);
  const [filteredUnassignedAttributes, setFilteredUnassignedAttributes] =
    useState([]);
  const [assignedAttributes, setAssignedAttributes] = useState([]);
  const [filteredAssignedAttributes, setFilteredAssignedAttributes] = useState(
    []
  );
  const [isOpenUnAssignedAttributes, setIsOpenUnAssignedAttributes] =
    useState(false);

  // react-select option lists
  const categoryOptions = allCategories.map((cat) => ({
    value: cat.CategoryId,
    label: cat.CategoryName,
  }));
  const brandOptions = allBrands.map((br) => ({
    value: br.BrandId,
    label: br.Brand1,
  }));
  // react-select controlled values
  const selectedCategoryOptions = selectedCategories.map((cat) => ({
    value: cat.CategoryId,
    label: cat.CategoryName,
  }));
  const selectedBrandOptions = selectedBrands.map((br) => ({
    value: br.BrandId,
    label: br.Brand1,
  }));

  // DataTable column definitions
  const unassignedAttributeValuesColumns = [
    { name: "ID", selector: (row) => row.AttributeValueId, sortable: true },
    {
      name: "Attribute Value",
      selector: (row) => row.AttributeValueName,
      sortable: true,
    },
    { name: "Attribute", selector: (row) => row.Attribute1, sortable: true },
    {
      name: "Assign",
      cell: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignAttributeValue(row)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];
  const assignedAttributeValuesColumns = [
    { name: "ID", selector: (row) => row.AttributeValueId, sortable: true },
    {
      name: "Attribute Value",
      selector: (row) => row.AttributeValueName,
      sortable: true,
    },
    { name: "Attribute", selector: (row) => row.Attribute1, sortable: true },
    {
      name: "Unassign",
      cell: (row) => (
        <button
          className="btn btn-outline-danger btn-sm ms-2"
          onClick={() => UnAssignAttributeValue(row.AttributeValueId)}
        >
          <MdOutlineDelete />
        </button>
      ),
    },
  ];
  const unassignedAttributesColumns = [
    { name: "ID", selector: (row) => row.AttributeId, sortable: true },
    { name: "Attribute", selector: (row) => row.Attribute1, sortable: true },
    {
      name: "Assign",
      cell: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignAttribute(row)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];
  const assignedAttributesColumns = [
    { name: "ID", selector: (row) => row.AttributeId, sortable: true },
    { name: "Attribute", selector: (row) => row.Attribute1, sortable: true },
    {
      name: "Unassign",
      cell: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnAssignAttribute(row.AttributeId)}
        >
          <MdOutlineDelete />
        </button>
      ),
    },
  ];

  // API actions for Attribute Values
  async function AssignAttributeValue(row) {
    const res = await fetch(
      `${Variables.API_URL}Group/AssignAttributeValueToGroup`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          AttributeValueId: row.AttributeValueId,
          GroupId: GroupID,
        }),
      }
    );
    const msg = await res.json();
    if (res.ok) {
      toast.success(msg);
      fetchUnAssignedAttributeValues();
      fetchAssignedAttributeValues();
    } else {
      toast.error(msg);
    }
  }
  async function UnAssignAttributeValue(AttributeValueId) {
    const res = await fetch(
      `${Variables.API_URL}Group/UnassignAttributeValueToGroup`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ AttributeValueId, GroupId: GroupID }),
      }
    );
    const msg = await res.json();
    if (res.ok) {
      toast.success(msg);
      fetchAssignedAttributeValues();
      fetchUnAssignedAttributeValues();
    } else {
      toast.error(msg);
    }
  }
  const fetchUnAssignedAttributeValues = async () => {
    const res = await fetch(
      `${Variables.API_URL}Group/GetUnAssignedAttributeValues/${GroupID}`
    );
    if (res.ok) {
      const list = await res.json();
      setUnassignedAttributeValues(list);
      setFilteredUnassignedAttributeValues(list);
    }
  };
  const fetchAssignedAttributeValues = async () => {
    const res = await fetch(
      `${Variables.API_URL}Group/GetAssignedAttributeValues/${GroupID}`
    );
    if (res.ok) {
      const list = await res.json();
      setAssignedAttributeValues(list);
      setFilteredAssignedAttributeValues(list);
    }
  };
  function handleSearchUnAssignedAttributeValues(e) {
    const v = e.target.value.toLowerCase();
    setFilteredUnassignedAttributeValues(
      unassignedAttributeValues.filter((item) =>
        item.AttributeValueName.toLowerCase().includes(v)
      )
    );
  }
  function handleSearchAssignedAttributeValues(e) {
    const v = e.target.value.toLowerCase();
    setFilteredAssignedAttributeValues(
      assignedAttributeValues.filter((item) =>
        item.AttributeValueName.toLowerCase().includes(v)
      )
    );
  }

  // API actions for Attributes
  async function AssignAttribute(row) {
    const res = await fetch(
      `${Variables.API_URL}Group/AssignAttributeToGroup`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          AttributeId: row.AttributeId,
          GroupId: GroupID,
        }),
      }
    );
    const msg = await res.json();
    if (res.ok) {
      toast.success(msg);
      fetchUnAssignedAttributes();
      fetchAssignedAttributes();
    } else {
      toast.error(msg);
    }
  }
  async function UnAssignAttribute(AttributeId) {
    const res = await fetch(
      `${Variables.API_URL}Group/UnassignAttributeToGroup`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ AttributeId, GroupId: GroupID }),
      }
    );
    const msg = await res.json();
    if (res.ok) {
      toast.success(msg);
      fetchAssignedAttributes();
      fetchUnAssignedAttributes();
    } else {
      toast.error(msg);
    }
  }
  const fetchUnAssignedAttributes = async () => {
    const res = await fetch(
      `${Variables.API_URL}Group/GetUnAssignedAttributes/${GroupID}`
    );
    if (res.ok) {
      const list = await res.json();
      setUnassignedAttributes(list);
      setFilteredUnassignedAttributes(list);
    }
  };
  const fetchAssignedAttributes = async () => {
    const res = await fetch(
      `${Variables.API_URL}Group/GetAssignedAttributes/${GroupID}`
    );
    if (res.ok) {
      const list = await res.json();
      setAssignedAttributes(list);
      setFilteredAssignedAttributes(list);
    }
  };
  function handleSearchUnAssignedAttributes(e) {
    const v = e.target.value.toLowerCase();
    setFilteredUnassignedAttributes(
      unassignedAttributes.filter((item) =>
        item.Attribute1.toLowerCase().includes(v)
      )
    );
  }
  function handleSearchAssignedAttributes(e) {
    const v = e.target.value.toLowerCase();
    setFilteredAssignedAttributes(
      assignedAttributes.filter((item) =>
        item.Attribute1.toLowerCase().includes(v)
      )
    );
  }

  // API actions for Categories & Brands
  async function GetCategories() {
    const res = await fetch(`${Variables.API_URL}Category/GetCategories`);
    if (res.ok) {
      const list = await res.json();
      setAllCategories(list);
      if (list.length && GroupID !== "0") {
        GetAssignedCategories();
      }
    }
  }
  async function GetAssignedCategories() {
    const res = await fetch(
      `${Variables.API_URL}Group/GetAssignedCategories/${GroupID}`
    );
    if (res.ok) {
      const list = await res.json();
      setSelectedCategories(list);
    }
  }
  async function GetBrands() {
    const res = await fetch(`${Variables.API_URL}Brand/GetBrandsForDdl`);
    if (res.ok) {
      const list = await res.json();
      setAllBrands(list);
      if (list.length && GroupID !== "0") {
        GetAssignedBrands();
      }
    }
  }
  async function GetAssignedBrands() {
    const res = await fetch(
      `${Variables.API_URL}Group/GetAssignedBrands/${GroupID}`
    );
    if (res.ok) {
      const list = await res.json();
      setSelectedBrands(list);
    }
  }
  async function GetGroup() {
    const res = await fetch(`${Variables.API_URL}Group/GetGroup/${GroupID}`);
    if (res.ok) {
      const obj = await res.json();
      setName(obj.GroupName);
    }
  }

  function IsValid() {
    return name.trim() !== "";
  }
  function handleSubmit(e) {
    e.preventDefault();
    if (!IsValid()) {
      toast.error("Please fill all required fields!");
      return;
    }
    const payload = { GroupName: name };
    if (GroupID === "0") {
      // Add new
      fetch(`${Variables.API_URL}Group/AddGroup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).then((res) =>
        res.json().then((id) => {
          if (res.ok) {
            toast.success("Added successfully");
            navigate(`/admin/gazelle/Groups/${id}`);
            // assign cats & brands
            fetch(`${Variables.API_URL}Group/AssignCategoriesToGroup/${id}`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(
                selectedCategories.map((c) => ({
                  GroupId: id,
                  CategoryId: c.CategoryId,
                }))
              ),
            });
            fetch(`${Variables.API_URL}Group/AssignBrandsToGroup/${id}`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(
                selectedBrands.map((b) => ({ GroupId: id, BrandId: b.BrandId }))
              ),
            });
          } else {
            toast.error(id);
          }
        })
      );
    } else {
      // Update existing
      fetch(`${Variables.API_URL}Group/UpdateGroup/${GroupID}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).then((res) =>
        res.json().then((msg) => {
          if (res.ok) {
            toast.success("Updated successfully");
            navigate("/admin/gazelle/Groups");
            fetch(
              `${Variables.API_URL}Group/AssignCategoriesToGroup/${GroupID}`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(
                  selectedCategories.map((c) => ({
                    GroupId: GroupID,
                    CategoryId: c.CategoryId,
                  }))
                ),
              }
            );
            fetch(`${Variables.API_URL}Group/AssignBrandsToGroup/${GroupID}`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(
                selectedBrands.map((b) => ({
                  GroupId: GroupID,
                  BrandId: b.BrandId,
                }))
              ),
            });
          } else {
            toast.error(msg);
          }
        })
      );
    }
  }

  useEffect(() => {
    if (GroupID !== "0") {
      fetchUnAssignedAttributeValues();
      fetchAssignedAttributeValues();
      fetchUnAssignedAttributes();
      fetchAssignedAttributes();
    }
    GetCategories();
    GetBrands();
    GetGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        {/* Header & breadcrumbs */}
        <div className="row mb-3">
          <div className="col-12">
            <h2>{GroupID === "0" ? "Add" : "Manage"} Group</h2>
            <ul className="portalPath">
              <li>
                Home <AiOutlineRight />
              </li>
              <li>
                <Link to="/admin/gazelle/Menu">
                  Groups <AiOutlineRight />
                </Link>
              </li>
              <li>Manage Group</li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {/* Actions */}
                <div className="row mb-3">
                  <div className="col-12 text-end">
                    <NavLink to="/admin/gazelle/Groups" className="btn btn-secondary">
                      Cancel
                    </NavLink>
                    <button
                      className="btn btn-primary m-1"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  </div>
                </div>

                {/* Form inputs */}
                <div className="row">
                  <div className="col-lg-4">
                    {/* Group Name */}
                    <div className="mb-4">
                      <label className="mb-2">
                        Group Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Group Name..."
                      />
                    </div>

                    {/* Categories */}
                    <div className="mb-4">
                      <label className="mb-2">Categories</label>
                      <Select
                        isMulti
                        options={categoryOptions}
                        value={selectedCategoryOptions}
                        placeholder="Select categories…"
                        onChange={(opts) =>
                          setSelectedCategories(
                            opts.map((o) => ({
                              CategoryId: o.value,
                              CategoryName: o.label,
                            }))
                          )
                        }
                      />
                    </div>

                    {/* Brands */}
                    <div>
                      <label className="mb-2">Brands</label>
                      <Select
                        isMulti
                        options={brandOptions}
                        value={selectedBrandOptions}
                        placeholder="Select brands…"
                        onChange={(opts) =>
                          setSelectedBrands(
                            opts.map((o) => ({
                              BrandId: o.value,
                              Brand1: o.label,
                            }))
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Attributes & Values */}
                {GroupID !== "0" && (
                  <>
                    {/* Assigned Attributes */}
                    <div className="row mt-4">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-6">
                            <h5 className="card-title">Assigned Attributes</h5>
                          </div>
                          <div className="col-6 text-end">
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                setIsOpenUnAssignedAttributes(true)
                              }
                            >
                              Assign Attribute
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col-8"></div>
                          <div className="col-4 position-relative">
                            <MdOutlineManageSearch className="position-absolute" />
                            <input
                              type="text"
                              placeholder="Search…"
                              className="form-control form-control-sm ps-4"
                              onChange={handleSearchUnAssignedAttributes}
                            />
                          </div>
                        </div>
                        <DataTable
                          columns={unassignedAttributesColumns}
                          data={filteredUnassignedAttributes}
                          pagination
                        />
                      </div>
                      {/* Assign Attribute Modal */}
                      <Modal
                        show={isOpenUnAssignedAttributes}
                        onHide={() => setIsOpenUnAssignedAttributes(false)}
                        dialogClassName="w-max"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Assign Attributes</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="position-relative mb-3">
                            <MdOutlineManageSearch className="position-absolute" />
                            <input
                              type="text"
                              placeholder="Search…"
                              className="form-control form-control-sm ps-4"
                              onChange={handleSearchUnAssignedAttributes}
                            />
                          </div>
                          <DataTable
                            columns={unassignedAttributesColumns}
                            data={filteredUnassignedAttributes}
                            pagination
                          />
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => setIsOpenUnAssignedAttributes(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>

                    {/* Assigned Attribute Values */}
                    <div className="row mt-4">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-6">
                            <h5 className="card-title">
                              Assigned Attribute Values
                            </h5>
                          </div>
                          <div className="col-6 text-end">
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                setIsOpenUnAssignedAttributeValues(true)
                              }
                            >
                              Assign Attribute Value
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col-8"></div>
                          <div className="col-4 position-relative">
                            <MdOutlineManageSearch className="position-absolute" />
                            <input
                              type="text"
                              placeholder="Search…"
                              className="form-control form-control-sm ps-4"
                              onChange={handleSearchUnAssignedAttributeValues}
                            />
                          </div>
                        </div>
                        <DataTable
                          columns={unassignedAttributeValuesColumns}
                          data={filteredUnassignedAttributeValues}
                          pagination
                        />
                      </div>
                      {/* Assign Attribute Value Modal */}
                      <Modal
                        show={isOpenUnAssignedAttributeValues}
                        onHide={() => setIsOpenUnAssignedAttributeValues(false)}
                        dialogClassName="w-max"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Assign Attribute Values</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="position-relative mb-3">
                            <MdOutlineManageSearch className="position-absolute" />
                            <input
                              type="text"
                              placeholder="Search…"
                              className="form-control form-control-sm ps-4"
                              onChange={handleSearchUnAssignedAttributeValues}
                            />
                          </div>
                          <DataTable
                            columns={unassignedAttributeValuesColumns}
                            data={filteredUnassignedAttributeValues}
                            pagination
                          />
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() =>
                              setIsOpenUnAssignedAttributeValues(false)
                            }
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>

                    {/* Currently Assigned Attributes & Values Tables */}
                    <div className="row mt-4">
                      <div className="col-6">
                        <h5>Assigned Attributes</h5>
                        <div className="position-relative mb-2">
                          <MdOutlineManageSearch className="position-absolute" />
                          <input
                            type="text"
                            placeholder="Search…"
                            className="form-control form-control-sm ps-4"
                            onChange={handleSearchAssignedAttributes}
                          />
                        </div>
                        <DataTable
                          columns={assignedAttributesColumns}
                          data={filteredAssignedAttributes}
                          pagination
                        />
                      </div>
                      <div className="col-6">
                        <h5>Assigned Attribute Values</h5>
                        <div className="position-relative mb-2">
                          <MdOutlineManageSearch className="position-absolute" />
                          <input
                            type="text"
                            placeholder="Search…"
                            className="form-control form-control-sm ps-4"
                            onChange={handleSearchAssignedAttributeValues}
                          />
                        </div>
                        <DataTable
                          columns={assignedAttributeValuesColumns}
                          data={filteredAssignedAttributeValues}
                          pagination
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageGroup;
